// La liste des candidatures envoyées, à copier (issue #170).
//
// Un demandeur d'emploi inscrit au Forem, chez Actiris ou au VDAB doit prouver
// ses démarches : quand, chez qui, pour quel poste. Radar a tout cela dans le
// journal des candidatures ; il ne manquait que de le rendre en texte, une
// ligne par candidature, à coller dans un formulaire ou un mail. Pas de
// fichier : un texte se colle partout, un fichier se perd.

import type { SuiviRow } from './api'
import { parseDate } from './format'

/** « 14/10/2026 · IBA · Software engineer · https://… », la plus ancienne
 *  d'abord. Seules les candidatures envoyées comptent. */
export function listePreuve(ks: Pick<SuiviRow, 'envoyeeLe' | 'company' | 'source_name' | 'title' | 'offerUrl'>[]): string {
  return ks
    .filter((k) => k.envoyeeLe && parseDate(k.envoyeeLe))
    .sort((a, b) => a.envoyeeLe!.localeCompare(b.envoyeeLe!))
    .map((k) => {
      const d = parseDate(k.envoyeeLe)!
      const jour = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
      return [jour, k.company ?? k.source_name, k.title, k.offerUrl].filter(Boolean).join(' · ')
    })
    .join('\n')
}
